import { Page } from '../models/Elements';
import { PhytosanitaryProduct } from '../models/Entities';
import { coreApiAxios } from './CustomAxios';

class PhytosanitaryProductApi {
    list = async (
        page: number,
        size: number,
        sortField: string,
        sortOrder: boolean,
        registerNumber?: string,
        name?: string
    ): Promise<Page<PhytosanitaryProduct>> => {
        const response = await coreApiAxios.get<Page<PhytosanitaryProduct>>('/phytosanitary-products', {
            params: { page, size, sortField, sortOrder, registerNumber, name }
        });
        response.data.sort.field = sortField;
        response.data.sort.order = sortOrder;

        return response.data;
    };
}

const phytosanitaryProductApi = new PhytosanitaryProductApi();
export default phytosanitaryProductApi;
